<template>
  <div v-if="visible" class="popup-block">
    <div class="form-popup-default">
      <v-card>
        <v-btn
          class="close-button"
          title="Отменить"
          variant="text"
          text
          @click="$emit('cancel')"
        >
          <v-icon>ti-close</v-icon>
        </v-btn>

        <div>
          <v-card-title>{{ title }}</v-card-title>

          <v-card-text>
            <v-form>
              <v-container>
                <v-row>
                  <label class="pd-lr-10 mb-4 pr-7 pl-7 text-center">
                    {{ text }}
                  </label>

                  <div class="text-center">
                    <v-btn
                      class="btnSave mr-4 primary-btn"
                      @click="$emit('confirm')"
                    >
                      {{ confirmLabel }}
                    </v-btn>

                    <v-btn
                      class="btnSave btnClose"
                      color="default"
                      @click="$emit('cancel')"
                    >
                      {{ cancelLabel }}
                    </v-btn>
                  </div>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Подтвердите действие"
    },
    text: {
      type: String,
      required: true
    },
    confirmLabel: {
      type: String,
      default: "ОК"
    },
    cancelLabel: {
      type: String,
      default: "Отмена"
    }
  }
};
</script>
